import React from 'react'
import CardFrame from '../CardFrame'
import RewardCardCreditVoucherCard from '../RewardCard/RewardCardCreditVoucherCard'
import { getFormattedPriceString } from '../../../../helpers/priceHelper'
import i18next from 'i18next'
import CardTitle from '../CardTitle'
import useSitecoreContext from '../../../../hooks/useSitecoreContext'
import { formatNumber } from '../../../../helpers/numberFormatHelper'
import { Box, Text } from 'theme-ui'
import SitecoreButton from '../../SitecoreButton/SitecoreButton'
import { PayWithPointsDatasourceProps } from '../../../organisms/PayWithPointsWrapper/PayWithPointsWrapper'

interface PayWithPointsCardProps {
  creditValue: {
    currencyCode: string
    value?: number
  }
  costPriceInPoints: number
  minimalSalesOrderValue: number
  type: string
  datasource: PayWithPointsDatasourceProps
}

const PayWithPointsCard = ({
  creditValue,
  costPriceInPoints,
  minimalSalesOrderValue,
  type,
  datasource,
}: PayWithPointsCardProps) => {
  const {
    languageContext: { cultureCode },
  } = useSitecoreContext()

  return (
    <>
      <CardFrame>
        <RewardCardCreditVoucherCard
          creditValue={creditValue}
          type={type}
          variant="minimal"
        />

        <CardTitle
          title={`${getFormattedPriceString(
            cultureCode,
            creditValue?.currencyCode,
            creditValue?.value
          )} ${i18next.t('shoppingLabels.customerLoyalty.discount')}`}
        />

        <Box
          sx={{
            marginBlock: 16,
          }}
        >
          <Text as="p" variant="bodySmall" color="gray.3">
            <b>{formatNumber(costPriceInPoints, cultureCode)}</b>&nbsp;
            {i18next.t('shoppingLabels.customerLoyalty.points')}
          </Text>

          <Text as="p" variant="smallText">
            {`${i18next.t(
              'shoppingLabels.customerLoyalty.minOrderValue'
            )}: ${getFormattedPriceString(
              cultureCode,
              creditValue.currencyCode,
              minimalSalesOrderValue
            )}`}
          </Text>
        </Box>

        <SitecoreButton
          linkField={datasource.viewInBasket}
          variant="infinite"
          color="primary"
        />
      </CardFrame>
    </>
  )
}

export default PayWithPointsCard
